module.exports = __webpack_public_path__ + "img/DW365-261.ecec7a26.jpg";